import React, { useState } from 'react';
import { getAllReferences } from '../data/references';

function ResourcesSection() {
  const [isExpanded, setIsExpanded] = useState(false);
  const allReferences = getAllReferences();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
      <div className="bg-slate-50 rounded-lg border border-slate-200 p-6">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-full flex items-center justify-between text-left"
        >
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              <i className="fas fa-book-open text-purple-600 mr-3"></i>
              Compliance Resources & Legal Guides
            </h2>
            <p className="text-gray-600">
              In-depth articles and guides from Compliance Hub covering children's privacy laws,
              age verification, and regulatory requirements
            </p>
          </div>
          <i className={`fas fa-chevron-${isExpanded ? 'up' : 'down'} text-2xl text-purple-600 ml-4`}></i>
        </button>

        {isExpanded && (
          <div className="mt-6 pt-6 border-t border-gray-200">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {allReferences.map((ref, idx) => (
                <a
                  key={idx}
                  href={ref.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block p-5 bg-gradient-to-br from-purple-50 to-white hover:from-purple-100 hover:to-purple-50 rounded-lg border-2 border-purple-100 hover:border-purple-300 transition-all card-hover group"
                >
                  <div className="flex items-start justify-between mb-2">
                    <i className="fas fa-file-alt text-purple-600 text-xl"></i>
                    <i className="fas fa-external-link-alt text-purple-400 group-hover:text-purple-600 text-sm"></i>
                  </div>
                  <h3 className="font-bold text-gray-900 mb-2 group-hover:text-purple-700">
                    {ref.title}
                  </h3>
                  <p className="text-sm text-gray-600">{ref.description}</p>
                </a>
              ))}
            </div>

            <div className="mt-6 p-4 bg-blue-50 border-l-4 border-blue-400 rounded">
              <p className="text-sm text-blue-900">
                <i className="fas fa-info-circle mr-2"></i>
                <strong>Note:</strong> These articles are provided by Compliance Hub and offer
                detailed analysis, compliance guidance, and practical implementation advice for
                navigating children's privacy regulations.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ResourcesSection;
